export const REACT_APP_APIURL = process.env.REACT_APP_APIURL;
export const REACT_APP_GLOBAL_URL = process.env.REACT_APP_GLOBAL_URL;
